import React from "react";
import {Alert, Snackbar} from "@mui/material";
import { useSnackbarStore } from "../../store/snackbarStore";

const GlobalSnackbar: React.FC = () => {
    const {open, message, severity, duration, closeMessage} = useSnackbarStore();

    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            onClose={closeMessage}
            anchorOrigin={{vertical: "top", horizontal: "center"}}
        >
            <Alert onClose={closeMessage} severity={severity} variant="filled" sx={{width: "100%"}}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default GlobalSnackbar;
